import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { MktEmailTemplate } from 'app/modules/app-components/mkt-email-template-dialog/mkt-email-template-dialog.component';
import { MktSMSTemplate } from 'app/modules/app-components/mkt-sms-template-dialog/mkt-sms-template-dialog.component';

import { HelperService } from 'app/services/helper.service';
import { campaignTypes, marketingTemplateTypes, emailTemplateTypes } from 'app/constants/marketing.constants';

import { AnnouncementTemplateView } from 'app/modules/marketing/components/announcement-email-template/announcement-template-view.component';
import { ProductTemplateViewComponent } from 'app/modules/marketing/components/product-template-view/product-template-view.component';
import { DataService, HTTPService } from 'app/services';
import { MarketingEmailTemplateViewComponent } from 'app/modules/marketing/components/marketing-email-template/marketing-email-template-view.component';
import { findIndex } from 'lodash';

@Component({
  selector: 'app-mkt-template-type-dialog',
  templateUrl: './mkt-template-type-dialog.component.html',
  styleUrls: ['./mkt-template-type-dialog.component.scss'],
})
export class MktTemplateType implements OnInit {
  campaignTypes = campaignTypes;
  marketingTemplateTypes = marketingTemplateTypes;
  options: any[] = [
    {
      label: 'Template type',
      key: 'templateType',
      icon: 'far fa-clone',
      subOptions: [
        {
          label: 'SMS',
          value: marketingTemplateTypes.SMS,
          icon: 'fal fa-sms',
        },
      ],
    },
    {
      label: 'Campaign type',
      key: 'campaignType',
      icon: 'far fa-stream',
      subOptions: [
        {
          label: 'Promotional',
          value: campaignTypes.PROMOTIONAL,
          icon: 'fal fa-megaphone',
        },
        {
          label: 'Follow-up',
          value: campaignTypes.FOLLOWUP,
          icon: 'fal fa-alarm-clock',
        },
      ],
    },
  ];
  emailTemplateOptions: any[] = [
    {
      label: 'Default',
      value: emailTemplateTypes.DEFAULT,
      icon: 'fal fa-pencil-paintbrush',
    },
    {
      label: 'Festive',
      value: emailTemplateTypes.FESTIVE,
      icon: 'fal fa-gifts',
    },
    {
      label: 'Announcement',
      value: emailTemplateTypes.ANNOUNCEMENT,
      icon: 'fal fa-bullhorn',
    },
    {
      label: 'Modern',
      value: emailTemplateTypes.MODERN,
      icon: 'fal fa-paper-plane',
    },
    {
      label: 'Products & Services',
      value: emailTemplateTypes.PRODUCT_SERVICES,
      icon: 'fal fa-bags-shopping',
    },
    {
      label: 'Newsletter',
      value: emailTemplateTypes.NEWSLETTER,
      icon: 'fal fa-newspaper',
    },
    {
      label: 'Classic',
      value: emailTemplateTypes.CLASSIC,
      icon: 'fal fa-star-christmas',
    },
  ];
  template = {
    templateType: '',
    campaignType: '',
    emailTemplateType: emailTemplateTypes.DEFAULT,
  };
  company: any = {};
  role: string = '';
  isMarketingEmailEnabled: boolean = false;

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private helperService: HelperService,
    private httpService: HTTPService,
    private dataService: DataService,
  ) {}

  ngOnInit() {
    this.getLocationDetails();
    this.isMarketingEmailEnabled = this.dataService.isMarketingEmailEnabled;

    if (this.isMarketingEmailEnabled && findIndex(this.options[0].subOptions, { value: marketingTemplateTypes.EMAIL }) === -1)
      this.options[0].subOptions.push({
        label: 'Email',
        value: marketingTemplateTypes.EMAIL,
        icon: 'fal fa-envelope',
      });
  }

  async getLocationDetails() {
    const { isMultiLocationEnabled, companyId } = this.helperService.getCompany();
    const shopId = this.dataService.currentShopId;

    try {
      if (isMultiLocationEnabled) {
        this.company = await this.httpService.getShopDetail(companyId, shopId);
      } else {
        this.company = await this.httpService.getCompanyDetails(companyId);
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  handleChange(name: string, value: string) {
    this.template[name] = value;

    const { templateType, campaignType } = this.template;

    if (templateType !== this.marketingTemplateTypes.EMAIL || campaignType !== this.campaignTypes.PROMOTIONAL) {
      this.template.emailTemplateType = emailTemplateTypes.DEFAULT;
    }
  }

  handleClose(isSuccess: boolean = false) {
    this.dynamicDialogRef.close({ isSuccess });
  }

  handleSave() {
    if (!this.template.templateType) {
      return this.helperService.showToaster('error', 'Please select template type');
    }

    if (!this.template.campaignType) {
      return this.helperService.showToaster('error', 'Please select campaign type');
    }

    if (this.template.emailTemplateType !== emailTemplateTypes.DEFAULT) {
      let component: any;

      if (this.template.emailTemplateType === emailTemplateTypes.PRODUCT_SERVICES) {
        component = ProductTemplateViewComponent;
      } else if (this.template.emailTemplateType === emailTemplateTypes.ANNOUNCEMENT) {
        component = AnnouncementTemplateView;
      } else {
        component = MarketingEmailTemplateViewComponent;
      }

      this.handleClose();
      this.dialogService.open(component, {
        styleClass: 'add-dialog mkt-announcement-template-dialog',
        showHeader: false,
        data: {
          campaignType: this.template.campaignType,
          companyDetails: this.company,
          type: this.template.emailTemplateType,
        },
      });
      return;
    }

    const component = this.template.templateType === marketingTemplateTypes.EMAIL ? MktEmailTemplate : MktSMSTemplate;

    this.handleClose();
    this.dialogService.open(component, {
      styleClass: 'add-dialog mkt-email-template-dialog',
      showHeader: false,
      data: { campaignType: this.template.campaignType },
    });
  }
}
